import CustomerDebtPage from './CustomerDebtPage.jsx';
import CtasCtesPlaceholder from './CtasCtesPlaceholder.jsx';
import ExportacionArcaPage from './ExportacionArcaPage.jsx';
import SubdiarioIvaVentasPage from './SubdiarioIvaVentasPage.jsx';
import AccountStatementsPage from './AccountStatementsPage.jsx';
import AjustesSaldoPage from './AjustesSaldoPage.jsx';
import ConsultaCreditosDebitosPage from './ConsultaCreditosDebitosPage.jsx';

export const clipperCtasCtesRoutes = {
  '/ctasctes/cuenta-corriente-clientes/deuda-de-clientes': <CustomerDebtPage />,
  '/ctasctes/cuenta-corriente-clientes/resumen-de-cuenta': <AccountStatementsPage />,
  '/ctasctes/cuenta-corriente-clientes/consulta-creditos-y-debitos': <ConsultaCreditosDebitosPage />,
  '/ctasctes/cuenta-corriente-clientes/consolidacion-de-cuentas': (
    <CtasCtesPlaceholder title="Consolidacion de Cuentas" category="Cuenta Corriente Clientes" />
  ),
  '/ctasctes/cuenta-corriente-clientes/ajustes-de-saldo': <AjustesSaldoPage />,
  '/ctasctes/facturacion-y-fiscal/informe-remitos-por-factura': (
    <CtasCtesPlaceholder title="Informe de Remitos por Factura" category="Facturacion y Fiscal" />
  ),
  '/ctasctes/facturacion-y-fiscal/impresion-masiva-de-envios': (
    <CtasCtesPlaceholder title="Impresion Masiva de Envios" category="Facturacion y Fiscal" />
  ),
  '/ctasctes/facturacion-y-fiscal/control-previo-a-liquidar-al-cliente': (
    <CtasCtesPlaceholder
      title="Control Previo a Liquidar al Cliente"
      category="Facturacion y Fiscal"
    />
  ),
  '/ctasctes/facturacion-y-fiscal/despachos-por-cliente': (
    <CtasCtesPlaceholder title="Despachos por Cliente" category="Facturacion y Fiscal" />
  ),
  '/ctasctes/facturacion-y-fiscal/subdiario-iva-ventas': (
    <SubdiarioIvaVentasPage />
  ),
  '/ctasctes/facturacion-y-fiscal/informe-ibcm': (
    <CtasCtesPlaceholder title="Informe para IBCM" category="Facturacion y Fiscal" />
  ),
  '/ctasctes/facturacion-y-fiscal/percepciones-emitidas': (
    <ExportacionArcaPage />
  ),
  '/ctasctes/facturacion-y-fiscal/percepciones-retenciones-agip': (
    <CtasCtesPlaceholder
      title="Percepciones y Retenciones AGIP"
      category="Facturacion y Fiscal"
    />
  ),
  '/ctasctes/facturacion-y-fiscal/retenciones-percepciones-mendoza': (
    <CtasCtesPlaceholder
      title="Retenciones y Percepciones Mendoza"
      category="Facturacion y Fiscal"
    />
  ),
  '/ctasctes/facturacion-y-fiscal/regimen-compras-ventas-rg-3685': (
    <ExportacionArcaPage />
  ),
  '/ctasctes/facturacion-y-fiscal/exportacion-arca': (
    <ExportacionArcaPage />
  ),
  '/ctasctes/contrareembolsos-y-retornables/contrareembolsos-por-viajes': (
    <CtasCtesPlaceholder title="Contrareembolsos por Viajes" category="Contrareembolsos y Retornables" />
  ),
  '/ctasctes/contrareembolsos-y-retornables/consulta-retornables-por-viaje': (
    <CtasCtesPlaceholder
      title="Consulta de Retornables por Viaje"
      category="Contrareembolsos y Retornables"
    />
  ),
  '/ctasctes/contrareembolsos-y-retornables/documentacion-devoluciones-por-servicios': (
    <CtasCtesPlaceholder
      title="Documentacion y Devoluciones por Servicios"
      category="Contrareembolsos y Retornables"
    />
  ),
  '/ctasctes/cruces-y-ajustes/cruces-de-facturacion': (
    <CtasCtesPlaceholder title="Cruces de Facturacion" category="Cruces y Ajustes" />
  ),
  '/ctasctes/cruces-y-ajustes/consulta-de-cruces-emitidos': (
    <CtasCtesPlaceholder title="Consulta de Cruces Emitidos" category="Cruces y Ajustes" />
  ),
  '/ctasctes/cruces-y-ajustes/facturar-diferencias-del-cruce': (
    <CtasCtesPlaceholder title="Facturar Diferencias del Cruce" category="Cruces y Ajustes" />
  ),
  '/ctasctes/cruces-y-ajustes/emitir-ajustes-credito-segun-cruce': (
    <CtasCtesPlaceholder title="Emitir Ajustes Credito segun Cruce" category="Cruces y Ajustes" />
  ),
  '/ctasctes/cruces-y-ajustes/emitir-ajustes-debito-segun-cruce': (
    <CtasCtesPlaceholder title="Emitir Ajustes Debito segun Cruce" category="Cruces y Ajustes" />
  ),
  '/ctasctes/revalorizaciones/revalorizacion-masiva-viajes-cliente': (
    <CtasCtesPlaceholder
      title="Revalorizacion Masiva de Viajes Cliente"
      category="Revalorizaciones"
    />
  ),
  '/ctasctes/revalorizaciones/revalorizacion-viajes-cerrados': (
    <CtasCtesPlaceholder title="Revalorizacion de Viajes Cerrados" category="Revalorizaciones" />
  ),
  '/ctasctes/revalorizaciones/revalorizacion-masiva-viajes-chofer': (
    <CtasCtesPlaceholder
      title="Revalorizacion Masiva de Viajes Chofer"
      category="Revalorizaciones"
    />
  ),
  '/ctasctes/revalorizaciones/revalorizacion-masiva-unidades-contratadas': (
    <CtasCtesPlaceholder
      title="Revalorizacion Masiva de Unidades Contratadas"
      category="Revalorizaciones"
    />
  ),
  '/ctasctes/reportes/analitico-de-deuda-clientes': (
    <CtasCtesPlaceholder title="Analitico de Deuda Clientes" category="Reportes" />
  ),
  '/ctasctes/reportes/saldos-historicos-de-clientes': (
    <CtasCtesPlaceholder title="Saldos Historicos de Clientes" category="Reportes" />
  ),
};
